/**
 * @generated SignedSource<<5a33a16498cc1990e03c79acd99e6767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PrimaryPlanStepQuery$variables = {
  offerIds?: ReadonlyArray<string> | null;
};
export type PrimaryPlanStepQuery$data = {
  readonly productOfferDetails: {
    readonly offerDetails: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"RelatedOfferFragment">;
    }>;
  };
};
export type PrimaryPlanStepQuery = {
  response: PrimaryPlanStepQuery$data;
  variables: PrimaryPlanStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "offerIds",
    "variableName": "offerIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKey",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longDescription",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrimaryPlanStepQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductOfferDetailsResponse",
        "kind": "LinkedField",
        "name": "productOfferDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BaseOfferDetail",
            "kind": "LinkedField",
            "name": "offerDetails",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RelatedOfferFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrimaryPlanStepQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductOfferDetailsResponse",
        "kind": "LinkedField",
        "name": "productOfferDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BaseOfferDetail",
            "kind": "LinkedField",
            "name": "offerDetails",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Price",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PriceFrequency",
                    "kind": "LinkedField",
                    "name": "frequency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "period",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePriceExcludingTax",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Entitlement",
                "kind": "LinkedField",
                "name": "entitlements",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Promotion",
                "kind": "LinkedField",
                "name": "promotions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractTerm",
                "kind": "LinkedField",
                "name": "contractTerm",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCharacteristic",
                "kind": "LinkedField",
                "name": "productCharacteristics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balanceManagement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerEligibilityLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relatedOfferId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relatedOfferIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferDetailCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dataLayerCategory",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6262caee1a0c3b92b1fc1b7e498b854b",
    "id": null,
    "metadata": {},
    "name": "PrimaryPlanStepQuery",
    "operationKind": "query",
    "text": "query PrimaryPlanStepQuery(\n  $offerIds: [String!]\n) {\n  productOfferDetails(offerIds: $offerIds) {\n    offerDetails {\n      ...RelatedOfferFragment\n    }\n  }\n}\n\nfragment RelatedOfferFragment on BaseOfferDetail {\n  id\n  description\n  name\n  contentKey\n  productType\n  price {\n    priceType\n    frequency {\n      period\n      value\n    }\n    basePrice\n    basePriceExcludingTax\n  }\n  entitlements {\n    name\n    shortDescription\n    longDescription\n    iconUrl\n    sortOrder\n    contentKey\n  }\n  promotions {\n    name\n    shortDescription\n    longDescription\n    productType\n    sortOrder\n    contentKey\n    iconUrl\n  }\n  contractTerm {\n    name\n  }\n  productCharacteristics {\n    balanceManagement\n    offerEligibilityLevel\n    relatedOfferId\n    relatedOfferIds\n  }\n  category {\n    id\n  }\n  dataLayerCategory\n}\n"
  }
};
})();

(node as any).hash = "511eb8800ad743a9f3e31c3bca9bae27";

export default node;
